import React from 'react';

const About: React.FC = () => {
  return (
    <div className="min-h-screen px-4 py-10 bg-gray-50 sm:px-6 sm:py-16">
      <section className="max-w-4xl p-6 mx-auto bg-white shadow-lg rounded-xl sm:p-12">
        <h1 className="mb-6 text-4xl font-bold text-center sm:text-5xl font-heading text-navy-900">Our Story</h1>
        <p className="mb-6 text-lg text-center text-gray-700 sm:text-xl">
          Blessed Gideon Charity was founded with a vision to bring hope, dignity, and opportunity to the most vulnerable across Africa. Our journey began with a simple act of kindness and has grown into a movement dedicated to fighting poverty, supporting orphaned children, and empowering communities.
        </p>
        <p className="mb-4 text-base text-black sm:text-lg">
          Over the years, we have witnessed the transformative power of compassion and collective action. From providing food and shelter to families in need, to building safe homes for orphans, and offering educational opportunities to youth, our mission is rooted in love and service.
        </p>
        <p className="mb-4 text-base text-gray-600 sm:text-lg">
          Our dedicated team, volunteers, and supporters work tirelessly to create sustainable change. We believe that every child deserves a future filled with hope, and every community deserves the chance to thrive. Together, we are building a legacy of impact—one life, one story at a time.
        </p>
        <p className="text-base text-gray-600 sm:text-lg">
          Thank you for being part of our story. Your support helps us continue this important work and reach even more lives in Africa and beyond.
        </p>
      </section>
    </div>
  );
};

export default About;
